import { Navigate } from 'react-router-dom';

export default function TraineeDashboard() {
  return <Navigate to="/formando-dashboard/financeiro" replace />
}